module.exports = __webpack_public_path__ + "media/packs/images/flags/PA-cb864891ab277667f151fec419d02220.svg";